__turbopack_context__.v({
  "label": "Label-module__JZ5kGW__label",
});
